// Probably in React V7
// This would be defined there ?
export const SORT_PARAM_KEY = "sort" as const;
export const SORT_SPLIT_CHAR = ":" as const;
export const SORT_ASC = "asc" as const;
export const SORT_DESC = "desc" as const;

export const PAGINATION_PAGE = "page" as const;
export const PAGINATION_ITEMS_PER_PAGE = "itemsPerPage" as const;
